import { UXB_EVENT_KEY } from 'supplier-portals/uxbeauty/constants';
import { EventProduct } from 'types/Products';
import { SearchDocument } from 'types/Search';
import { envs } from '../../../../../envs';

export const getProductPictureUrl = (document: SearchDocument | EventProduct) =>
  document.event?.images?.[0]?.reference
    ? `${envs.REACT_APP_COVALO_STATIC_CONTENT}/events/${UXB_EVENT_KEY}/${document.event.images[0].reference}`
    : undefined;
